import { render, staticRenderFns } from "./pathologyReport.vue?vue&type=template&id=684cd019&scoped=true"
import script from "./pathologyReport.vue?vue&type=script&lang=js"
export * from "./pathologyReport.vue?vue&type=script&lang=js"
import style0 from "./pathologyReport.vue?vue&type=style&index=0&id=684cd019&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cd019",
  null
  
)

export default component.exports